import { Location } from '../interfaces/location';
import { Provider } from '../interfaces/provider';
import { abortableFetch } from '../utils/utils';
import { CacheProvider } from '../providers/cache.provider';

/**
 * Main Collection Endpoint for Adena API
 * @todo refactor request urls to only return necessary data
 * @see https://docs.microsoft.com/en-us/odata/concepts/queryoptions-overview
 */
export class ApiService {
	private static debug = false;

	//@ts-ignore
	private static baseUrl: string = window.baseUrl || 'https://localhost:44352';

	public static cacheProvider = CacheProvider.getInstance();

	private static async getCachedCollection(
		endpointUrl: string,
		cacheKey: string,
		options: any = {},
		expiration: number = null
	) {
		const callback = async (url: string = null, carriedData: any[] = null) =>
			abortableFetch(url ? url : endpointUrl, options)
				.ready.then(res => res.json())
				.then(async data => {
					let _data = data.value;
					if (carriedData) {
						_data = [..._data, ...carriedData];
					}
					if (data['@odata.nextLink']) {
						// Option to recursively retrieve records
						// This is super slow, we should return each chunk as
						// we get it
						return callback(data['@odata.nextLink'], _data);
					}
          console.log(_data);
					return _data;
				});
		return await (this.debug
			? callback()
			: this.cacheProvider.getCacheData(cacheKey, callback, expiration));
	}

	public static async getLocations(): Promise<Location[]> {
		//let locationExpiration = 0; // 2hours
    let locationExpiration = 1000 * 60 * 60 * 2; // 2hours
		return this.getCachedCollection(
			`${this.baseUrl}/api/default/locations?$expand=LocationTypes,Areas,Image&$orderby=Title`,
			'locations_v3',
      {'headers': {'X-Requested-With': ''}}, 
			locationExpiration
		);
	}

	public static async getProviders(filterAmg: boolean = false): Promise<Provider[]> {
		let providerExpiration = 1000 * 60 * 60 * 24 * 2;
		return this.getCachedCollection(
			`${
				this.baseUrl
			}/api/default/providers?$filter=ProviderHidden+eq+false&$select=Id,PageUrl,UrlName,StartDate,Title,FirstName,MetaDescription,Fax,Address1,MetaTitle,Publications,Certifications,Phone,LeadershipTitle,AdenaStatus,Phone2,City,BioVideo,Languages,Gender,Bio,MiddleName,Address2,NPINumber,LastName,State,Zip,AcceptingAppointments,ProviderType&$expand=Specialties($select=Id),Locations($select=Id),Photo($select=Url,Title,AlternativeText,Thumbnails)&$orderby=Title${
				filterAmg ? '&$filter=AdenaMedicalGroup eq true' : ''
			}`,
			'providers',
      {'headers': {'X-Requested-With': ''}}, 
			providerExpiration
		);
	}

	public static async getSpecialties(): Promise<any[]> {
		return this.getCachedCollection(
			`${this.baseUrl}/api/default/specialties?$select=Id,Title,UrlName&$orderby=Title`,
			'specialties',
      {'headers': {'X-Requested-With': ''}}
		);
	}

  public static async getNews()  {
    let newsExpiration = 1000 * 60 * 60; // 1 hour
    return this.getCachedCollection(
			`${this.baseUrl}/api/default/newsitems?$select=*&$expand=FullNewsCategories($select=title, id, urlName),Image&$orderby=publicationDate desc`,
			'news',
      {
        'headers': {
          'X-Requested-With': ''
        },
      },
      newsExpiration

		);
  }

  public static async getNewsCategories()  {
    return this.getCachedCollection(
			`${this.baseUrl}/api/default/flat-taxa?$filter=TaxonomyId eq 53087cc5-3335-4384-a008-20a45e718545`,
			'news-categories',
      {'headers': {'X-Requested-With': ''}}
		);
  }

  public static async getHeros() {
    let heroExpiration = 1000 * 60 * 60 * 6; // 6 hours
    return this.getCachedCollection(
			`${this.baseUrl}/api/default/heros?$expand=callstoaction($expand=iconimage),slides($expand=image)`,
			'hp-heros',
      {'headers': {'X-Requested-With': ''}},
      heroExpiration
		);
  }

  
}
